import React, { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FieldDerivation = ({
  Show,
  Hide,
  Title,
  schemaId,
  studyId,
  formFieldData,
  getStudySchemaFormFieldList,
}) => {
  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [formFieldList, setFormFieldList] = useState([]);
  const [assignedEventId, setAssignedEventId] = useState("");
  const [assignedTimepointId, setAssignedTimepointId] = useState("");
  const [assignedFormId, setAssignedFormId] = useState("");
  const [assignedFormVersion, setAssignedFormVersion] = useState("");
  const [assignedFieldId, setAssignedFieldId] = useState("");
  const [eventLoader, setEventLoader] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const [fieldLoader, setFieldLoader] = useState(false);

  const getEventBasedonSchema = async () => {
    setEventLoader(true);
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(
      studyId,
      schemaId
    );
    setEventList(data?.data || []);
    setEventLoader(false);
  };

  const getStudyFormBasedonSchemaEvent = async () => {
    setFormLoader(true);
    let data =
      await studyEventFormSchemaServices.getStudyFormBasedonSchemaEvent(
        studyId,
        schemaId,
        assignedEventId,
        assignedTimepointId || "no"
      );
    setFormList(data?.data || []);
    setFormLoader(false);
  };

  const getStudyLevelFormFieldsByVersion = async () => {
    setFieldLoader(true);
    let data =
      await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
        studyId,
        assignedFormId,
        assignedFormVersion
      );
    setFormFieldList(data?.data?.formFields || []);
    setFieldLoader(false);
  };

  const assignFormFieldinSchema = async () => {
    let userData = {};
    userData.studyId = studyId;
    userData.schemaId = schemaId;
    userData.eventId = formFieldData?.eventId;
    userData.timePointUniqueId = formFieldData?.timePointUniqueId || "";
    userData.formId = formFieldData?.formId;
    userData.formVersion = formFieldData?.formVersion;
    userData.fieldId = formFieldData?.fieldId;
    userData.derivation = {
      eventId: assignedEventId,
      timePointUniqueId: assignedTimepointId || "",
      formId: assignedFormId,
      formVersion: assignedFormVersion,
      fieldId: assignedFieldId,
    };
    let data = await studyEventFormSchemaServices.assignFormFieldinSchema(
      userData
    );
    if (data?.statusCode === 200) {
      getStudySchemaFormFieldList();
      Hide();
    }
  };

  useEffect(() => {
    if (assignedFormId && assignedFormVersion) {
      getStudyLevelFormFieldsByVersion();
    }
  }, [assignedFormId, assignedFormVersion]);

  useEffect(() => {
    if (schemaId && assignedEventId) {
      getStudyFormBasedonSchemaEvent();
    }
  }, [schemaId, assignedEventId]);

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema();
    }
  }, [schemaId]);

  useEffect(() => {
    setAssignedEventId(formFieldData?.fieldDerivation?.eventId);
    setAssignedTimepointId(formFieldData?.fieldDerivation?.timePointUniqueId);
    setAssignedFormId(formFieldData?.fieldDerivation?.formId);
    setAssignedFormVersion(formFieldData?.fieldDerivation?.formVersion);
    setAssignedFieldId(formFieldData?.fieldDerivation?.fieldId);
  }, [formFieldData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {eventLoader || formLoader || fieldLoader ? (
            <PageLoader />
          ) : (
            <>
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">
                  Events{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  className="br3"
                  style={{ fontSize: 12 }}
                  onChange={(e) => {
                    setAssignedEventId(e.target.value);
                    setAssignedTimepointId(e.target[e.target.selectedIndex].id);
                  }}
                  required
                >
                  <option value="" id="">
                    Select Event
                  </option>
                  {eventList?.map((item, index) => (
                    <option
                      selected={
                        `${item.eventId}${
                          item?.row?.["TIMEPOINTUNIQUEID"] || ""
                        }` === `${assignedEventId}${assignedTimepointId}`
                      }
                      key={index}
                      value={item.eventId}
                      id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}
                    >
                      {item?.row?.["EVENTID"]}{" "}
                      {item?.row?.["TIMEPOINTUNIQUEID"] &&
                        `(${item?.row?.["TIMEPOINTID"]})`}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">
                  Forms{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  className="br3"
                  style={{ fontSize: 12 }}
                  onChange={(e) => {
                    setAssignedFormId(e.target.value);
                    setAssignedFormVersion(e.target[e.target.selectedIndex].id);
                  }}
                  required
                >
                  <option value="" id="">
                    Select Form
                  </option>
                  {formList?.map((item, index) => (
                    <option
                      selected={item?.formId === assignedFormId}
                      key={index}
                      value={item?.formId}
                      id={item.formVersion}
                    >
                      {item.formLabel}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label className="mb-1 fw-bold">
                  Fields{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  onChange={(e) => setAssignedFieldId(e.target.value)}
                  className="br3"
                  style={{ fontSize: 12 }}
                  required
                >
                  <option value="">Select Field</option>
                  {formFieldList?.map((item, index) => (
                    <option
                      selected={item?.id === Number(assignedFieldId)}
                      key={index}
                      value={item?.id}
                    >
                      {item.fieldLabel}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-gold border-top shadow-sm text-end">
          <button
            onClick={assignFormFieldinSchema}
            disabled={
              !assignedEventId ||
              !assignedFormId ||
              !assignedFormVersion ||
              !assignedFieldId ||
              !schemaId
            }
            className="updateProfile"
          >
            Assign
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default FieldDerivation;
